var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-data-details"},[_c('div',{staticClass:"details-top"},[_c('div'),_c('el-button',{staticClass:"blue-btn",on:{"click":_vm.toBack}},[_vm._v("返回")])],1),_c('div',{staticClass:"details-bottom"},[_c('AccountDetail',{attrs:{"initId":Number(_vm.$route.query.id),"isChangeAccount":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }